<template>
  <div class="node-header-wrapper">
    <h1 class="meta-stack-item">{{ nodeHeading }}</h1>

    <div class="update-statement">
      <span class="statement" :class="getReadStateClass" @click="reopen">{{ ago(clusterDate(clusterIndex)) }}</span>
      <div class="actions">
        <!-- <div class="action bookmark" @click="bookmark()">
          <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.00001 0.5H3.00001C2.40327 0.5 1.83097 0.737053 1.40902 1.15901C0.987059 1.58097 0.750006 2.15326 0.750006 2.75V14.75C0.749481 14.8822 0.783887 15.0121 0.849739 15.1267C0.915592 15.2413 1.01055 15.3364 1.12501 15.4025C1.23902 15.4683 1.36835 15.503 1.50001 15.503C1.63166 15.503 1.76099 15.4683 1.87501 15.4025L6.00001 13.0175L10.125 15.4025C10.2393 15.4673 10.3686 15.5009 10.5 15.5C10.6314 15.5009 10.7607 15.4673 10.875 15.4025C10.9895 15.3364 11.0844 15.2413 11.1503 15.1267C11.2161 15.0121 11.2505 14.8822 11.25 14.75V2.75C11.25 2.15326 11.013 1.58097 10.591 1.15901C10.169 0.737053 9.59674 0.5 9.00001 0.5ZM9.75001 13.4525L6.37501 11.5025C6.26099 11.4367 6.13166 11.402 6.00001 11.402C5.86835 11.402 5.73902 11.4367 5.62501 11.5025L2.25001 13.4525V2.75C2.25001 2.55109 2.32902 2.36032 2.46968 2.21967C2.61033 2.07902 2.80109 2 3.00001 2H9.00001C9.19892 2 9.38968 2.07902 9.53034 2.21967C9.67099 2.36032 9.75001 2.55109 9.75001 2.75V13.4525Z" fill="#6D7479"/>
          </svg>
          <transition name="fadeleft" mode="out-in">
            <div class="bookmark-confirm" v-show="reveal.bookmark">
              Bookmarks coming soon
            </div>
          </transition>
        </div> -->
        <div class="action share" @click.stop="shareItem('link')">
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.2803 6.46959L9.28025 0.46959C9.17536 0.364733 9.04174 0.293328 8.89627 0.264403C8.75081 0.235477 8.60003 0.250329 8.46301 0.307082C8.32598 0.363834 8.20886 0.459939 8.12645 0.583246C8.04404 0.706554 8.00003 0.851527 8 0.99984V3.65859C5.95122 3.84818 4.04692 4.79549 2.65977 6.31511C1.27262 7.83474 0.502454 9.81731 0.5 11.8748V12.9998C0.500118 13.1555 0.548682 13.3073 0.638956 13.4342C0.729229 13.561 0.856737 13.6566 1.00379 13.7077C1.15085 13.7588 1.31017 13.7629 1.45965 13.7194C1.60913 13.6759 1.74136 13.5869 1.838 13.4648C2.57277 12.5911 3.47432 11.8725 4.48996 11.3511C5.5056 10.8297 6.61497 10.5159 7.75325 10.4281C7.79075 10.4236 7.8845 10.4161 8 10.4086V12.9998C8.00003 13.1482 8.04404 13.2931 8.12645 13.4164C8.20886 13.5397 8.32598 13.6358 8.46301 13.6926C8.60003 13.7494 8.75081 13.7642 8.89627 13.7353C9.04174 13.7064 9.17536 13.6349 9.28025 13.5301L15.2803 7.53009C15.4209 7.38944 15.4998 7.19871 15.4998 6.99984C15.4998 6.80097 15.4209 6.61024 15.2803 6.46959ZM9.5 11.1893V9.62484C9.5 9.42593 9.42098 9.23516 9.28033 9.09451C9.13968 8.95386 8.94891 8.87484 8.75 8.87484C8.55875 8.87484 7.778 8.91234 7.5785 8.93859C5.55715 9.12484 3.63306 9.8928 2.039 11.1496C2.21993 9.49542 3.00465 7.9661 4.24292 6.85446C5.48118 5.74282 7.08596 5.12698 8.75 5.12484C8.94891 5.12484 9.13968 5.04582 9.28033 4.90517C9.42098 4.76452 9.5 4.57375 9.5 4.37484V2.81034L13.6895 6.99984L9.5 11.1893Z" fill="#6D7479"/>
          </svg>
          <transition name="fadeleft" mode="out-in">
            <div class="bookmark-confirm" v-if="reveal.link">
              Copied to clipboard
            </div>
          </transition>
        </div>
        <!-- <div class="action share" @click="share()">
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.2803 6.46959L9.28025 0.46959C9.17536 0.364733 9.04174 0.293328 8.89627 0.264403C8.75081 0.235477 8.60003 0.250329 8.46301 0.307082C8.32598 0.363834 8.20886 0.459939 8.12645 0.583246C8.04404 0.706554 8.00003 0.851527 8 0.99984V3.65859C5.95122 3.84818 4.04692 4.79549 2.65977 6.31511C1.27262 7.83474 0.502454 9.81731 0.5 11.8748V12.9998C0.500118 13.1555 0.548682 13.3073 0.638956 13.4342C0.729229 13.561 0.856737 13.6566 1.00379 13.7077C1.15085 13.7588 1.31017 13.7629 1.45965 13.7194C1.60913 13.6759 1.74136 13.5869 1.838 13.4648C2.57277 12.5911 3.47432 11.8725 4.48996 11.3511C5.5056 10.8297 6.61497 10.5159 7.75325 10.4281C7.79075 10.4236 7.8845 10.4161 8 10.4086V12.9998C8.00003 13.1482 8.04404 13.2931 8.12645 13.4164C8.20886 13.5397 8.32598 13.6358 8.46301 13.6926C8.60003 13.7494 8.75081 13.7642 8.89627 13.7353C9.04174 13.7064 9.17536 13.6349 9.28025 13.5301L15.2803 7.53009C15.4209 7.38944 15.4998 7.19871 15.4998 6.99984C15.4998 6.80097 15.4209 6.61024 15.2803 6.46959ZM9.5 11.1893V9.62484C9.5 9.42593 9.42098 9.23516 9.28033 9.09451C9.13968 8.95386 8.94891 8.87484 8.75 8.87484C8.55875 8.87484 7.778 8.91234 7.5785 8.93859C5.55715 9.12484 3.63306 9.8928 2.039 11.1496C2.21993 9.49542 3.00465 7.9661 4.24292 6.85446C5.48118 5.74282 7.08596 5.12698 8.75 5.12484C8.94891 5.12484 9.13968 5.04582 9.28033 4.90517C9.42098 4.76452 9.5 4.57375 9.5 4.37484V2.81034L13.6895 6.99984L9.5 11.1893Z" fill="#6D7479"/>
          </svg>
          <transition name="fadeleft" mode="out-in">
            <div class="share-options" v-show="reveal.share">
              <li class="facebook" @click.stop="shareItem('facebook')">
                <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.93937 8.76855V15H5.34796V8.76855H7.88971L8.41863 5.90332H5.34796V4.88965C5.34796 3.375 5.94446 2.79492 7.48421 2.79492C7.96317 2.79492 8.34811 2.80664 8.57143 2.83008V0.231445C8.15123 0.117188 7.12278 0 6.52921 0C3.38802 0 1.93937 1.47949 1.93937 4.66992V5.90332H0V8.76855H1.93937Z" fill="white"/>
                </svg>
              </li>

              <li class="twitter" @click.stop="shareItem('twitter')">
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5615 0H12.6191L8.12516 5.08269L13.4118 12H9.27341L6.02976 7.80577L2.32272 12H0.26229L5.06803 6.5625L0 0H4.24327L7.17218 3.83365L10.5615 0ZM9.83879 10.7827H10.9783L3.62252 1.15385H2.3985L9.83879 10.7827Z" fill="white"/>
                </svg>
              </li>

              <li class="linkedin" @click.stop="shareItem('linkedin')">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.35826 15H0.247768V4.98549H3.35826V15ZM1.80134 3.61942C0.80692 3.61942 0 2.79576 0 1.80134C0 1.32359 0.189783 0.865417 0.5276 0.5276C0.865417 0.189783 1.32359 0 1.80134 0C2.27908 0 2.73726 0.189783 3.07508 0.5276C3.4129 0.865417 3.60268 1.32359 3.60268 1.80134C3.60268 2.79576 2.79576 3.61942 1.80134 3.61942ZM14.9967 15H11.8929V10.125C11.8929 8.96317 11.8694 7.47321 10.2757 7.47321C8.65848 7.47321 8.41071 8.73549 8.41071 10.0413V15H5.30357V4.98549H8.28683V6.35156H8.33036C8.74554 5.56473 9.76004 4.73437 11.2734 4.73437C14.4208 4.73437 15 6.80692 15 9.49888V15H14.9967Z" fill="white"/>
                </svg>
              </li>

              <li class="link" @click.stop="shareItem('link')">
                <svg width="19" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 5C6 5.26522 6.10536 5.51957 6.29289 5.70711C6.48043 5.89464 6.73478 6 7 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H7C6.73478 4 6.48043 4.10536 6.29289 4.29289C6.10536 4.48043 6 4.73478 6 5ZM8 8H5C4.20435 8 3.44129 7.68393 2.87868 7.12132C2.31607 6.55871 2 5.79565 2 5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H8C8.26522 2 8.51957 1.89464 8.70711 1.70711C8.89464 1.51957 9 1.26522 9 1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10H8C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 8.73478 8.89464 8.48043 8.70711 8.29289C8.51957 8.10536 8.26522 8 8 8ZM15 0H12C11.7348 0 11.4804 0.105357 11.2929 0.292893C11.1054 0.48043 11 0.734784 11 1C11 1.26522 11.1054 1.51957 11.2929 1.70711C11.4804 1.89464 11.7348 2 12 2H15C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5C18 5.79565 17.6839 6.55871 17.1213 7.12132C16.5587 7.68393 15.7956 8 15 8H12C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9C11 9.26522 11.1054 9.51957 11.2929 9.70711C11.4804 9.89464 11.7348 10 12 10H15C16.3261 10 17.5979 9.47322 18.5355 8.53553C19.4732 7.59785 20 6.32608 20 5C20 3.67392 19.4732 2.40215 18.5355 1.46447C17.5979 0.526784 16.3261 0 15 0Z" fill="white"/>
                </svg>
                <transition name="fadeup" mode="out-in">
                  <span class="popup" v-if="reveal.link">Link copied to clipboard</span>
                </transition>
              </li>
            </div>
          </transition>
        </div> -->
      </div>
    </div>

    <!-- <div class="update-statement">
      <div class="read-state" :class="getReadStateClass"><span>{{ getReadStateLabel }}</span></div>
      <span class="statement" :class="getReadStateClass" @click="reopen">{{ ago(clusterDate(clusterIndex)) }}</span>
      <div class="read-state" :class="getReadStateClass"><span>{{ getReadStateLabel }}</span></div>
      <div class="actions">
        <div class="action bookmark" @click="bookmark()">
          <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.00001 0.5H3.00001C2.40327 0.5 1.83097 0.737053 1.40902 1.15901C0.987059 1.58097 0.750006 2.15326 0.750006 2.75V14.75C0.749481 14.8822 0.783887 15.0121 0.849739 15.1267C0.915592 15.2413 1.01055 15.3364 1.12501 15.4025C1.23902 15.4683 1.36835 15.503 1.50001 15.503C1.63166 15.503 1.76099 15.4683 1.87501 15.4025L6.00001 13.0175L10.125 15.4025C10.2393 15.4673 10.3686 15.5009 10.5 15.5C10.6314 15.5009 10.7607 15.4673 10.875 15.4025C10.9895 15.3364 11.0844 15.2413 11.1503 15.1267C11.2161 15.0121 11.2505 14.8822 11.25 14.75V2.75C11.25 2.15326 11.013 1.58097 10.591 1.15901C10.169 0.737053 9.59674 0.5 9.00001 0.5ZM9.75001 13.4525L6.37501 11.5025C6.26099 11.4367 6.13166 11.402 6.00001 11.402C5.86835 11.402 5.73902 11.4367 5.62501 11.5025L2.25001 13.4525V2.75C2.25001 2.55109 2.32902 2.36032 2.46968 2.21967C2.61033 2.07902 2.80109 2 3.00001 2H9.00001C9.19892 2 9.38968 2.07902 9.53034 2.21967C9.67099 2.36032 9.75001 2.55109 9.75001 2.75V13.4525Z" fill="#6D7479"/>
          </svg>
          <transition name="fadeleft" mode="out-in">
            <div class="bookmark-confirm" v-show="reveal.bookmark">
              Bookmarks coming soon
            </div>
          </transition>
        </div>
        <div class="action share" @click="share()">
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.2803 6.46959L9.28025 0.46959C9.17536 0.364733 9.04174 0.293328 8.89627 0.264403C8.75081 0.235477 8.60003 0.250329 8.46301 0.307082C8.32598 0.363834 8.20886 0.459939 8.12645 0.583246C8.04404 0.706554 8.00003 0.851527 8 0.99984V3.65859C5.95122 3.84818 4.04692 4.79549 2.65977 6.31511C1.27262 7.83474 0.502454 9.81731 0.5 11.8748V12.9998C0.500118 13.1555 0.548682 13.3073 0.638956 13.4342C0.729229 13.561 0.856737 13.6566 1.00379 13.7077C1.15085 13.7588 1.31017 13.7629 1.45965 13.7194C1.60913 13.6759 1.74136 13.5869 1.838 13.4648C2.57277 12.5911 3.47432 11.8725 4.48996 11.3511C5.5056 10.8297 6.61497 10.5159 7.75325 10.4281C7.79075 10.4236 7.8845 10.4161 8 10.4086V12.9998C8.00003 13.1482 8.04404 13.2931 8.12645 13.4164C8.20886 13.5397 8.32598 13.6358 8.46301 13.6926C8.60003 13.7494 8.75081 13.7642 8.89627 13.7353C9.04174 13.7064 9.17536 13.6349 9.28025 13.5301L15.2803 7.53009C15.4209 7.38944 15.4998 7.19871 15.4998 6.99984C15.4998 6.80097 15.4209 6.61024 15.2803 6.46959ZM9.5 11.1893V9.62484C9.5 9.42593 9.42098 9.23516 9.28033 9.09451C9.13968 8.95386 8.94891 8.87484 8.75 8.87484C8.55875 8.87484 7.778 8.91234 7.5785 8.93859C5.55715 9.12484 3.63306 9.8928 2.039 11.1496C2.21993 9.49542 3.00465 7.9661 4.24292 6.85446C5.48118 5.74282 7.08596 5.12698 8.75 5.12484C8.94891 5.12484 9.13968 5.04582 9.28033 4.90517C9.42098 4.76452 9.5 4.57375 9.5 4.37484V2.81034L13.6895 6.99984L9.5 11.1893Z" fill="#6D7479"/>
          </svg>
          <transition name="fadeleft" mode="out-in">
            <div class="share-options" v-show="reveal.share">
              <li class="facebook" v-on:click="shareItem('facebook')">
                <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.93937 8.76855V15H5.34796V8.76855H7.88971L8.41863 5.90332H5.34796V4.88965C5.34796 3.375 5.94446 2.79492 7.48421 2.79492C7.96317 2.79492 8.34811 2.80664 8.57143 2.83008V0.231445C8.15123 0.117188 7.12278 0 6.52921 0C3.38802 0 1.93937 1.47949 1.93937 4.66992V5.90332H0V8.76855H1.93937Z" fill="white"/>
                </svg>
              </li>

              <li class="twitter" v-on:click="shareItem('twitter')">
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5615 0H12.6191L8.12516 5.08269L13.4118 12H9.27341L6.02976 7.80577L2.32272 12H0.26229L5.06803 6.5625L0 0H4.24327L7.17218 3.83365L10.5615 0ZM9.83879 10.7827H10.9783L3.62252 1.15385H2.3985L9.83879 10.7827Z" fill="white"/>
                </svg>
              </li>

              <li class="linkedin" v-on:click="shareItem('linkedin')">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.35826 15H0.247768V4.98549H3.35826V15ZM1.80134 3.61942C0.80692 3.61942 0 2.79576 0 1.80134C0 1.32359 0.189783 0.865417 0.5276 0.5276C0.865417 0.189783 1.32359 0 1.80134 0C2.27908 0 2.73726 0.189783 3.07508 0.5276C3.4129 0.865417 3.60268 1.32359 3.60268 1.80134C3.60268 2.79576 2.79576 3.61942 1.80134 3.61942ZM14.9967 15H11.8929V10.125C11.8929 8.96317 11.8694 7.47321 10.2757 7.47321C8.65848 7.47321 8.41071 8.73549 8.41071 10.0413V15H5.30357V4.98549H8.28683V6.35156H8.33036C8.74554 5.56473 9.76004 4.73437 11.2734 4.73437C14.4208 4.73437 15 6.80692 15 9.49888V15H14.9967Z" fill="white"/>
                </svg>
              </li>

              <li class="link" v-on:click="shareItem('link')">
                <svg width="19" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 5C6 5.26522 6.10536 5.51957 6.29289 5.70711C6.48043 5.89464 6.73478 6 7 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H7C6.73478 4 6.48043 4.10536 6.29289 4.29289C6.10536 4.48043 6 4.73478 6 5ZM8 8H5C4.20435 8 3.44129 7.68393 2.87868 7.12132C2.31607 6.55871 2 5.79565 2 5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H8C8.26522 2 8.51957 1.89464 8.70711 1.70711C8.89464 1.51957 9 1.26522 9 1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10H8C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 8.73478 8.89464 8.48043 8.70711 8.29289C8.51957 8.10536 8.26522 8 8 8ZM15 0H12C11.7348 0 11.4804 0.105357 11.2929 0.292893C11.1054 0.48043 11 0.734784 11 1C11 1.26522 11.1054 1.51957 11.2929 1.70711C11.4804 1.89464 11.7348 2 12 2H15C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5C18 5.79565 17.6839 6.55871 17.1213 7.12132C16.5587 7.68393 15.7956 8 15 8H12C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9C11 9.26522 11.1054 9.51957 11.2929 9.70711C11.4804 9.89464 11.7348 10 12 10H15C16.3261 10 17.5979 9.47322 18.5355 8.53553C19.4732 7.59785 20 6.32608 20 5C20 3.67392 19.4732 2.40215 18.5355 1.46447C17.5979 0.526784 16.3261 0 15 0Z" fill="white"/>
                </svg>
                <transition name="fadeup" mode="out-in">
                  <span class="popup" v-if="reveal.link">Link copied to clipboard</span>
                </transition>
              </li>
            </div>
          </transition>
        </div>
      </div>
    </div> -->
  
    <!-- <div v-if="clusterIndex == 0" class="synopsis">
      <p>{{ getCurrentStory.synopsis }}</p>
    </div> -->

    <!-- <div class="node-stats">
      <div class="stat">
        <span>{{ ago(clusterDate(clusterIndex)) }}</span>
      </div>
      <div class="breaker"></div>
      <div class="sources" @click="showPublishers(clusterPublishers(clusterIndex))">
        <div class="source" v-for="(source, idx) in clusterPublishers(clusterIndex).slice(0, 3)" :key="idx" :style="{ backgroundImage: 'url(' + source.icon + ')' }"></div>
        <span>
          {{ clusterPublishers(clusterIndex).length }} 
          {{ isLastCluster ? '' : 'futher' }} 
          {{ clusterPublishers(clusterIndex).length | plural('source') }} 
          {{ isLastCluster ? 'initially covered this story.' : 'covered this update.' }}
        </span>
      </div>
    </div> -->

    <!-- <div class="feature-tags" v-if="clusterTopics(clusterIndex).length > 0">
      <TopicTag :data="tag" v-for="tag in clusterTopics(clusterIndex).slice(0, 3)" :key="tag.topic_code" class="feature-tag"/>
    </div> -->

    <!-- <button @click="showGoalTestModal()">Show Goal Test Modal</button> -->

    <!-- <div class="content-meta meta-stack-item">
      <global-svg type="clock" class="icon" height="12px"/>
      <span class="meta-byline">Reported <span class="callout"> {{ago(clusterDate(clusterIndex))}}</span></span>
    </div>

    <div class="meta-stats meta-stack-item">
      <div class="inner-stat"><span class="callout">{{ metaPublishers }}</span> {{ metaPublishers | plural('source') }}</div>
      <div class="inner-stat"><span class="callout">{{ Math.ceil(metaRunningTime) }} {{ Math.ceil(metaRunningTime) | plural('day') }}</span> of reporting</div>
      <div class="inner-stat" v-if="metaUpdates > 1"><span class="callout">{{ metaUpdates }}</span> key story {{ metaUpdates | plural('update') }}</div>
    </div>

    <div class="meta-groups meta-stack-item">
      <div class="inner-group">
        <div class="inner-image" v-for="pub in clusterPublishers(clusterIndex).slice(0, 6)" :key="pub.code">
          <img :src="pub.icon"/>
        </div>
      </div>

      <div class="inner-group" v-if="clusterTopics(clusterIndex).length > 0">
        <div class="tag" v-for="(topic, idx) in clusterTopics(clusterIndex).slice(0, 3)" :key="idx">
          <TopicTag v-if="topic.topic_name" :topic="topic"/>
        </div>
      </div>
    </div>

    <div class="content-statements meta-stack-item" v-if="cluster.statements.length > 0">
      <div class="inner-statement" v-for="(statement, idx) in cluster.statements.slice(0, 6)" :key="idx">
        <span class="byline">{{ statement.cxx }} sources</span>
        <h3>{{ statement.name }}</h3>
      </div>
    </div> -->
  </div>
</template>

<script>
  import utils from '@assets/js/utils.js';
  import layout from '@assets/js/layout.js';
  import story from '@assets/js/news/story-utils.js';
  // import TopicTag from 'app/components/_v5/grid-elements/meta/TopicTag.vue' 

  export default {
    mixins: [story, utils, layout],

    data() {
      return {
        reveal: {
          bookmark: false,
          share: false,
          link: false,
        }
      }
    },

    props: {
      slug: String,
      node: String,
      nodeHeading: String,
      cluster: Object,
      clusterIndex: Number,
      focus: Boolean,
    },

    components: {
      // TopicTag,
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },
      
      isLastCluster() {
        return (this.clusterIndex + 1) >= this.clusters?.length;
      },

      getCurrentStory() {
        // console.log(this.$store.getters.getStoryV3(this.slug))
        return this.$store.getters.getStoryV3(this.slug) || {};
      },

      metaPublishers() {
        return this.getCurrentStory?.meta?.cx_pub || 0; 
      },

      metaUpdates() {
        return this.getCurrentStory?.clusters?.stats?.timeseries || 0; 
      },

      metaRunningTime() {
        let dLast = new Date(this.getCurrentStory.last_published_at).getTime();
        let dFirst = this.getCurrentStory?.clusters?.timeseries.map((a) => {return new Date(a.stats.mid).getTime()}).sort((a, b) => a > b ? 1 : -1)[0];
        let iOffset = (dLast - dFirst) / (86400 * 1000);
        return Math.max(1, iOffset);
      },

      getReadStateClass() {
        // switch (this.clusterReadState(this.clusterIndex).code) {
        if (this.clusterIndex > 0) {
          return 'unread';
        }
        switch (this.getStoryReadState?.code) {
          case 'read': return 'read';
          case 'skimmed': return 'skimmed';
          case 'glanced': return 'glanced';
        }
        return 'unread';
      },

      getReadStateLabel() {
        // switch (this.clusterReadState(this.clusterIndex).code) {
        if (this.clusterIndex > 0) {
          return 'Previously';
        }
        switch (this.getStoryReadState?.code) {
          case 'read': return 'Read';
          case 'skimmed': return 'Skimmed';
          case 'glanced': return 'Glanced';
        }
        return 'Unread';
      }
    },

    methods: {
      reopen() {
        window.open(document.location.href, '_blank');
      },

      showGoalTestModal() {
        this.EventBus.$emit('modal:goal', 'section-complete');
      },

      bookmark() {
        this.reveal.bookmark = true;
        setTimeout(() => {
          this.reveal.bookmark = false;
        }, 3000)
      },

      share() {
        this.reveal.share = !this.reveal.share;
      },

      shareItem(type) {
        let newFacebookWindow;
        let newTwitterWindow;
        let newLinkedInWindow;
        let link = `https://nourished.news/story/${this.slug}`;
        let buildTweet = this.nodeHeading;

        let linkedInUrl;
        let facebookUrl;
        let twitterUrl;
        let dummy = document.createElement('input');

        console.log(`Sharing: ${link}`);

        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'link',
              article: '',
              story: this.slug,
              heading: this.nodeHeading,
            }
          });
          return;
        }

        switch (type) {
          case 'twitter':
            twitterUrl = `https://twitter.com/share?text=${buildTweet}&url=${link}`;
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'twitter',
                  type: 'link',
                  link: twitterUrl
                }
              });
            } else {
              newTwitterWindow = window.open(`${twitterUrl}`, '_blank');
              if (newTwitterWindow) {
                newTwitterWindow.focus();
              }
            }
            break;
          case 'facebook':
            facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'facebook',
                  type: 'link',
                  link: facebookUrl
                }
              });
            } else {
              newFacebookWindow = window.open(`${facebookUrl}`, '_blank');
              if (newFacebookWindow) {
                newFacebookWindow.focus();
              }
            }
            break;
          case 'linkedin':
            linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${link}`
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'linkedin',
                  type: 'link',
                  link: linkedInUrl
                }
              });
            } else {
              newLinkedInWindow = window.open(`${linkedInUrl}`, '_blank');
              if (newLinkedInWindow) {
                newLinkedInWindow.focus();
              }
            }
            break
          case 'link':
            if (this.hasApp && this.story) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'link',
                  article: '',
                  story: this.slug,
                  heading: this.nodeHeading,
                }
              });
            } else {
              document.body.appendChild(dummy);
              dummy.value = link;
              dummy.select();
              document.execCommand('copy');
              document.body.removeChild(dummy);
              this.reveal.link = true;
              setTimeout(() => {
                this.reveal.link = false;
              }, 2000);

              setTimeout(() => {
                this.reveal.share = false;
              }, 2500);
              break;
            }
        }
      },

      showPublishers(publishers) {
        this.EventBus.$emit('modal:publishers',{ publishers: publishers });
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';

  .node-header-wrapper {    
    .mobile & {
      padding: 0 0.8em;
    }

    .meta-stack-item {
      display: inline-block;
      font-size: 2.0rem;
      margin-top: 0;
      margin-bottom: .5em;
      &.content-meta {
        margin-top: 1em;
      }
    }

    .synopsis {
      border-left: 3px solid $yellow-tone-3;
      padding: 0em .5em;
      margin: 1em 0em;
      text-wrap: pretty;
      font-size: 1.1em;
    }
  }

  .update-statement {
    display: flex;
    align-items: center;
    position: relative;
    padding: 0.3rem 0 1.5rem 0;
    color: $neutral-400;

    .statement {
      display: inline-block;
      position: relative;
      width: 100%;
      font-size: 0.9rem;
      
      &::after {
        content: '';
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 1px;
        background: rgba($neutral-400, 0.2);
        top: 10px;
        z-index: 40;
        margin-left: 1rem;
      }

      // &.read {
      //   &::after {
      //     background: $green-tone-3;
      //   }
      // }

      // &.skimmed {
      //   &::after {
      //     background: $yellow-tone-3;
      //   }
      // }

      // &.glanced {
      //   &::after {
      //     background: $orange-tone-3;
      //   }
      // }
    }

    .read-state {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.1rem 0.6rem 0.2rem 0.6rem;
      background: $neutral-500;
      border-radius: 500px;
      z-index: 50;
      font-weight: bold;
      color: $neutral-100;
      font-size: 0.8rem;
      margin-top: 2px;
      color: $neutral-100;
      margin-right: 0.5rem;

      .darkmode & {
        background: $neutral-400;
      }

      span {
        display: inline-block;
      }

      &.read {
        background: $green-tone-3;
        color: $neutral-600;
      }

      &.skimmed {
        background: $yellow-tone-3;
        color: $neutral-600;
      }

      &.glanced {
        background: $orange-tone-3;
        color: $neutral-600;
      }
    }

    .actions {
      display: flex;
      $action-size: 2.5rem;
      cursor: pointer;
      padding-top: 1px;
      margin-left: 0.5rem;

      .action {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc($action-size + 0.2rem);
        height: calc($action-size + 0.2rem);
        background: $neutral-500;
        z-index: 50;
        border-radius: 500px;
        border: 2px solid $neutral-600;
        margin-left: 0.1rem;

        &:hover {
          background: $yellow-tone-3;

          svg path {
            fill: $yellow-tone-7;
          }
        }

        &.bookmark {
          padding-right: 0.043rem;
        }

        &.share {
          padding-right: 0.01rem;
        }

        &.share svg {
          margin-bottom: 2px;
        }

        .darkmode & {
          background: $neutral-300;
          border: 2px solid $neutral-100;

          &:hover {
            background: $yellow-tone-3;
          }
        }
      }

      .bookmark-confirm {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -2px;
        right: 0;
        height: $action-size;
        padding: 0 0.8rem;
        background: $yellow-tone-3;
        color: $yellow-tone-7;
        white-space: nowrap;
        font-size: 0.8rem;
        border-radius: 500px;
        padding-bottom: 0px;
      }

      .share-options {
        position: absolute;
        top: -2px;
        right: 0;
        display: flex;
        list-style: none;
        z-index: 20;
        padding-top: 1px;
        padding-right: 4px;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          width: $action-size;
          height: $action-size;
          margin-right: 0.25rem;
          border-radius: 500px;

          &:last-child {
            margin-right: calc($action-size + 0.1rem);
          }

          &.facebook {
            background: $facebook;
            padding-top: 2px;

            svg path {
              fill: $neutral-600;
            }
          }

          &.twitter {
            background: #000000;
            padding: 2px 0 0 1px;

            svg path {
              fill: $neutral-600;
            }
          }

          &.linkedin {
            background: $linkedin;

            svg path {
              fill: $neutral-600;
            }
          }

          &.link {
            padding-top: 3px;
            background: $yellow-tone-3;

            svg path {
              fill: $neutral-100;
            }
          }
        }

        .popup {
          background: $yellow-tone-7;
          border-radius: 500px;
          font-size: 11px;
          color: $white-primary;
          padding: 0.5em;
          width: 144px;
          display: block;
          text-align: center;
          position: absolute;
          top: -30px;
          right: -10px;
          margin-left: -72px;
          pointer-events: none;
        }
      }
    }
  }

  h1 {
    @include typo-size-headline;
    font-size: 1.75rem;
    // margin: 0 1em 0.7em 0;

    .mq-sm & {
      // font-size: 1.25rem;
    }
  }

  .node-stats {
    display: flex;
    align-items: center;
    margin: 1rem 0;
    color: $neutral-400;
    font-size: 0.9rem;

    .breaker {
      margin: 0.75rem;
      width: 5px;
      height: 5px;
      background: $neutral-400;
      border-radius: 500px;
    }

    .stat {
      display: flex;      
      .icon {
        margin-right: 0.4rem;
      }
    }

    .sources {
      display: flex;
      align-items: center;
      cursor: pointer;

      .source {
        background-size: cover;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;

        &:not(:first-child) {
          margin-left: -0.5rem;
        }
      }

      span {
        display: inline-block;
        margin-left: 0.5rem;
      }
    }
  }

  .feature-tags {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;

    .mobile & {
      flex-wrap: nowrap;
      max-width: 100vw;
      overflow: hidden;
      overflow-x: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    
    .feature-tag {
      margin-right: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  .content-meta {
    @include meta-tag; // @jason? why did you remove this?

    .node-body[data-index="0"] & {
      background: none;
    }

    display: flex;
    align-items: center;

    .icon {
      margin-bottom: 2px;
    }

    .meta-byline {
      @include typo-size-body-small;
      margin-left: 0.5em;
      font-weight: normal;

      .callout {
        font-weight: bold;
      }

      ///
    }
  }

  .content-statements {
    display: -webkit-box;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    margin: 1em 0;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }

    .desktop & {
      display: none;
    }

    .inner-statement {
      width: 75%;
      border-left: 3px solid $yellow-tone-3;
      padding-left: 0.8em;
      scroll-snap-align: start;

      .byline {
        display: inline-block;
        @include typo-size-small;
        margin-bottom: 0.7em;
        margin-top: 0;
      }

      h3 {
        @include typo-size-body;
        margin-top: 0;
        margin-bottom: 0;
        line-height: 1.4;
      }

      &:not(:last-child) {
        margin-right: 1em;
      }
    }
  }

  .meta-stats {
    display: flex;
    margin: 1em 0;

    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    
    .inner-stat {
      @include meta-tag;
    }

    .node-body:not([data-index="0"]) & {
      display: none;
    }
  }

  .meta-groups {
    display: -webkit-box;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .desktop & {
      display: none;
    }

    .inner-group {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-right: 0.7em;
      }

      .inner-image {
        width: 38px;
        height: 38px;
        
        &:not(:first-child) {
          margin-left: -0.8em;
        }

        .mobile & {
          width: 32px;
          height: 32px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          border: 1px solid $neutral-500;
        }
      }

      .tag:not(:last-child) {
        margin-right: 0.3em;
      }
    }
  }
</style>